import { Box, Text, Title } from "@mantine/core";
import { CheckIcon } from "@phosphor-icons/react";
import React from "react";
import classes from "./invoice-section-card.module.css";

type Props = {
  id: string;
  title: string;
  children: React.ReactNode;
  stepNumber: number;
  isCompleted?: boolean;
  isActive?: boolean;
  hint?: React.ReactNode;
  badge?: React.ReactNode;
  action?: React.ReactNode;
  flush?: boolean;
};

export function InvoiceSectionCard({
  id,
  title,
  children,
  stepNumber,
  isCompleted,
  isActive,
  hint,
  badge,
  action,
  flush,
}: Props) {
  const state = isCompleted ? "done" : isActive ? "active" : "pending";

  return (
    <Box
      id={id}
      component="section"
      className={`${classes.card}${flush ? ` ${classes.cardFlush}` : ""}`}
    >
      <Box className={classes.header}>
        <Box className={classes.titleGroup}>
          <Box component="span" className={classes.num} data-state={state}>
            {isCompleted ? <CheckIcon size={12} weight="bold" /> : stepNumber}
          </Box>
          <Title order={2} className={classes.title}>
            {title}
          </Title>
          {badge ? (
            typeof badge === "string" || typeof badge === "number" ? (
              <Text span className={classes.pill}>
                {badge}
              </Text>
            ) : (
              badge
            )
          ) : null}
          {hint ? (
            typeof hint === "string" ? (
              <Text span className={classes.hint}>
                {hint}
              </Text>
            ) : (
              hint
            )
          ) : null}
        </Box>
        {action ? <Box className={classes.actions}>{action}</Box> : null}
      </Box>
      <Box className={classes.body}>{children}</Box>
    </Box>
  );
}
